// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.searchBox[data-v-78eea1f3] .selectClass .el-input__inner {\n  font-weight: 600 !important;\n}\n.SearchExpansion[data-v-78eea1f3] {\n  padding: 4px 20px;\n  font-size: 20px;\n  cursor: pointer;\n  border: 1px solid #cccccc;\n  border-radius: 5px;\n  margin-left: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
